<template>
  <div class="page-content">
    <p class="newMine_pageTitle newMine_pageTitleb m-b10">
      <span class="newMine_pageTitles">综合评价成绩</span>
    </p>
    <div v-if="examConfigId">
      <div class="newMine_form">
        <div class="newMine_iconTitle">
          <img src="../assets/gk/cj_1.png" alt="">
          <span class="newMine_icon_title">统考</span>
        </div>
        <el-form ref="form" :model="pageData" label-width="auto">
          <el-form-item label="考次" style="margin-bottom: 0;">
            <el-select v-model="examConfigId" placeholder="请选择" @change="getData" size="small">
              <el-option :label="e.name" :value="e.id" v-for="(e, i) in examConfigList" :key="i"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="newMine_table">
        <el-table :data="pageData.records" border :cell-style="tableStyle.cellStyle"
          :header-cell-style="tableStyle.headerCellStyle">
          <el-table-column prop="date" label="课程" width="180" show-overflow-tooltip>
            <template #default="{ row }">
              {{ row.courseCode + '-' + row.courseName }}
            </template>
          </el-table-column>
          <el-table-column prop="learningScore" label="学习成绩" width="100" show-overflow-tooltip></el-table-column>
          <el-table-column label="已答/作业套数" width="120" show-overflow-tooltip>
            <template #default="{ row }">
              {{ row.doneHomeworkCount }}/{{ row.totalTomeworkCount }}
            </template>
          </el-table-column>
          <el-table-column prop="homeworkFinalScore" label="作业成绩" width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="knowledgeScore" label="知识点测验成绩" width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="midtermExamFinalScore" label="综合测评成绩" width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="learningCheckScore" label="学习考勤成绩" width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="homeworkFinishScore" label="作业完成成绩" width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="integrityScore" label="诚信表现成绩" width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="totalScore" label="总成绩" width="100" show-overflow-tooltip></el-table-column>
        </el-table>
      </div>
    </div>
    <div style="margin: 30px 0;" v-if="examConfigId1">
      <div class="newMine_form">
        <div class="newMine_iconTitle">
          <img src="../assets/gk/cj_2.png" alt="">
          <span class="newMine_icon_title">省考</span>
        </div>
        <el-form ref="form" :model="pageData1" label-width="auto">
          <el-form-item label="考次" style="margin-bottom: 0;">
            <el-select v-model="examConfigId1" placeholder="请选择" @change="getData1" size="small">
              <el-option :label="e.name" :value="e.id" v-for="(e, i) in examConfigList1" :key="i"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="newMine_table">
        <el-table :data="pageData1.records" border :cell-style="tableStyle.cellStyle"
          :header-cell-style="tableStyle.headerCellStyle2">
          <el-table-column prop="date" label="课程" min-width="180" show-overflow-tooltip>
            <template #default="{ row }">
              {{ row.courseCode + '-' + row.courseName }}
            </template>
          </el-table-column>
          <el-table-column prop="learningProgress" label="学习进度" width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="doneHomeworkCount" label="作业次数" width="100" show-overflow-tooltip></el-table-column>


          <el-table-column label="作业成绩" show-overflow-tooltip min-width="120">
            <template #default="{ row }">
              {{ row.homeworkScore }}
              ({{ row.homeworkFinalScore }})
            </template>
          </el-table-column>
          <el-table-column prop="midtermExamFinalScore" label="考试成绩" width="120">
            <template #default="{ row }">
              {{ row.midtermExamScore }}
              ({{ row.midtermExamFinalScore }})
            </template>
          </el-table-column>
          <el-table-column prop="totalScore" label="综合成绩"></el-table-column>
        </el-table>

      </div>
    </div>
    <div style="margin: 30px 0;" v-if="examConfigId">
      <div class="newMine_form">
        <div class="newMine_iconTitle">
          <img src="../assets/gk/cj_1.png" alt="">
          <span class="newMine_icon_title2" style="font-size: 14px; left: 50px;">非专业课程</span>
        </div>
      </div>
      <div class="newMine_table">
        <el-table :data="pageData2.records" border :cell-style="tableStyle.cellStyle"
          :header-cell-style="tableStyle.headerCellStyle">
          <el-table-column prop="date" label="课程" width="180" show-overflow-tooltip>
            <template #default="{ row }">
              {{ row.courseCode + '-' + row.courseName }}
            </template>
          </el-table-column>
          <el-table-column prop="learningScore" label="学习成绩" width="100" show-overflow-tooltip></el-table-column>
          <el-table-column label="已答/作业套数" width="120" show-overflow-tooltip>
            <template #default="{ row }">
              {{ row.doneHomeworkCount }}/{{ row.totalTomeworkCount }}
            </template>
          </el-table-column>
          <el-table-column prop="homeworkFinalScore" label="作业成绩" width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="knowledgeScore" label="知识点测验成绩" width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="midtermExamFinalScore" label="综合测评成绩" width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="learningCheckScore" label="学习考勤成绩" width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="homeworkFinishScore" label="作业完成成绩" width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="integrityScore" label="诚信表现成绩" width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="totalScore" label="总成绩" width="100" show-overflow-tooltip></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"

export default {
  components: {
  },
  name: "Score",
  data() {
    return {
      tableStyle: {
        cellStyle: { textAlign: 'center' },
        headerCellStyle: {
          textAlign: 'center',
          background: '#E9EFF9',
          color: '#303133',
        },
        headerCellStyle2: {
          textAlign: 'center',
          background: '#FFF2E6',
          color: '#303133',
        },
      },
      loading: false,
      pageData: {
        current: 1,
        size: 999999,
        total: 0,
        records: [],
      },
      examConfigId: '',
      examConfigList: [],
      pageData1: {
        current: 1,
        size: 999999,
        total: 0,
        records: [],
      },
      examConfigId1: '',
      examConfigList1: [],
      pageData2: {
        current: 1,
        size: 999999,
        total: 0,
        records: [],
      },

    };
  },
  computed: {
    ...mapState([])
  },
  async created() {
    await this.getExamConfig()
    this.getData();
    this.getData1();
  },
  methods: {
    async getExamConfig() {//1-省考、2-统考
      await this.$http.get('/student/pc/getSchoolExamConfig', { examType: 2 }).then((res) => {
        this.examConfigList = res
        this.examConfigId = res[0]?.id
      })
      await this.$http.get('/student/pc/getSchoolExamConfig', { examType: 1 }).then((res) => {
        this.examConfigList1 = res
        this.examConfigId1 = res[0]?.id
      })
    },
    getData() {
      if(!this.examConfigId) return
      this.$http.get('/student/pc/getStudentScore', { current: this.pageData.current, size: this.pageData.size, examConfigId: this.examConfigId }).then(res => {
        this.pageData = res
      })
      this.getData2()
    },
    getData1() {
      if(!this.examConfigId1) return
      this.$http.get('/student/pc/getStudentScore', { current: this.pageData1.current, size: this.pageData1.size, examConfigId: this.examConfigId1 }).then(res => {
        this.pageData1 = res
      })
    },
    getData2() {
      if(!this.examConfigId) return
      this.$http.get('/student/pc/getStudentScore', { current: this.pageData2.current, size: this.pageData2.size, examConfigId: this.examConfigId, isNotSpecialty: 1 }).then(res => {
        this.pageData2 = res
      })
    },
  },
};
</script>
<style lang="scss" scoped>
.newMine_pageTitle {
  height: 80px;
  line-height: 80px;
  box-sizing: border-box;
  padding: 0 30px;
  font-weight: bold;
  font-size: 18px;
  color: #333;
}

.newMine_form {
  padding: 0 30px;
  display: flex;
  justify-content: space-between;
  align-items: end;

  .newMine_iconTitle {
    width: 137px;
    height: 54px;
    position: relative;
    margin-bottom: 12px;

    img {
      width: 100%;
      height: 100%;
    }

    .newMine_icon_title {
      font-weight: 400;
      font-size: 18px;
      color: #FFFFFF;
      position: absolute;
      bottom: 2px;
      left: 60px;
    }

    .newMine_icon_title2 {
      font-weight: 400;
      font-size: 18px;
      color: #FFFFFF;
      position: absolute;
      bottom: 7px;
      left: 60px;
    }
    
  }
}

.newMine_table {
  // min-height: 430px;
  padding: 0 30px;
}
</style>
